module.exports = __webpack_public_path__ + "static/media/tasksActive.5ca7d563.svg";